//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	props: {
		value: {
			type: String | null,
			required: true
		},
		placeholder: {
			type: String,
			required: false,
			default: 'Buscar'
		}
	},
	computed: {
		search: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	}
}
